export const DEFAULT_RESOLVE_RULE_ID = 'default_rule';
